import { Card, CardContent, Box, Typography, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export const TestSelectionSkeleton = () => (
	<Box p={3}>
		<Grid container spacing={{ xs: 4, md: 24 }}>
			{[1, 2, 3].map((i) => (
				<Grid size={{ xs: 12, md: 3 }} key={i}>
					<Card variant="outlined" sx={{ width: 280, borderRadius: 2 }}>
						<CardContent
							sx={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between',
								height: '100%',
								p: 2,
								gap: 1.5,
							}}
						>
							<Skeleton variant="text" width="70%" height={28} />
							<Box sx={{ height: 118 }}>
								<Skeleton variant="text" width="90%" />
								<Skeleton variant="text" width="95%" />
								<Skeleton variant="text" width="80%" />
							</Box>
							<Skeleton variant="text" width={100} height={32} />
							<Box sx={{ display: 'flex', justifyContent: 'center' }}>
								<Skeleton variant="rounded" width={160} height={40} />
							</Box>
						</CardContent>
					</Card>
				</Grid>
			))}
		</Grid>
		<Box mt={4}>
			<Typography variant="h6">
				<Skeleton width={120} />
			</Typography>
			<Box mt={2}>
				{[1, 2].map((i) => (
					<Box key={i} mb={1}>
						<Skeleton variant="text" width="40%" />
						<Skeleton variant="text" width="20%" />
					</Box>
				))}
			</Box>
			<Box>
				<Skeleton variant="text" width="20%" />
				<Skeleton variant="text" width="30%" />
				<Skeleton variant="text" width="25%" />
			</Box>
			<Typography variant="h6">
				<Skeleton width={150} />
			</Typography>
			<Box mt={1}>
				<Skeleton variant="text" width="40%" />
				<Skeleton variant="text" width="25%" />
			</Box>
			<Typography variant="h6">
				<Skeleton width={120} />
			</Typography>
			<Skeleton variant="rectangular" height={40} width={100} />
		</Box>
	</Box>
);
